import { EnumBase } from 'hay-core-react';
class UsuarioClassificacao extends EnumBase {
    constructor() {
        super(['main.usuario.classificacao.sistema','main.usuario.classificacao.hotspot'], "main.usuario.classificacao.sistema" );
    }
}
const instance = new UsuarioClassificacao();
export default instance;